export default "__VITE_ASSET__Y7IVnjif__"